<template>
	<div class="col-md-12" id="tablaInvo">
		<!-- <Loader v-if="$parent.isLoading"></Loader> -->
		<!-- tablaInvoKey: {{ $parent.tablaInvoKey }} -->
		<div class="contenedor-invoice">
			<table :class="[
					'table table-striped table-bordered table-hover invoList',
					($parent.cols.length>=8) ? 'allCols' : ''
				]"
			>
				<thead>
					<tr>
						<!--<th 
							v-for="(i,idx) in $parent.cols" 
							:key="idx" 
							:class="$parent.colsAll[i].class" 
							v-if="($parent.colsAll[i].id!=12 && $parent.cols.includes($parent.colsAll[i].id)) || ($parent.colsAll[i].id==12 && $parent.accessJobsApp) || ($parent.colsAll[i].id=13)"
						>
							{{i.name}}
						</th>-->
						<!-- <th class="colSelected" v-if="$parent.cols.includes('1')"></th> -->
						<th class="note">Note</th>
						<th class="numID" v-if="$parent.cols.includes('1')">Invoice Id#</th>
						<th class="date-due" v-if="$parent.cols.includes('3')">Due Date</th>
						<th class="customer" v-if="$parent.cols.includes('4')">Customer</th>
						<th class="name" v-if="$parent.cols.includes('5')">Name</th>
						<th class="total" v-if="$parent.cols.includes('6')" >Total</th>
						<th class="tax" v-if="$parent.cols.includes('7')" >Tax</th>
						<th class="balance" v-if="$parent.cols.includes('8')">Balance</th>
						<th class="status" v-if="$parent.cols.includes('9')">Status</th>
						<th class="send" v-if="$parent.cols.includes('11')">Email</th>
						<th class="jobs" v-if="$parent.cols.includes('12') && $parent.accessJobsApp && $parent.JobsInt==1">Job</th>
						<th class="calc" v-if="$parent.cols.includes('13')">Calc</th>
						<th class="actions"><i class="fas fa-ellipsis-h"></i></th>
					</tr>
				</thead>
				<tbody v-if="$parent.isLoading">
					<tr>
						<td :colspan="($parent.cols.length +1)" class="text-center">
							<Loader></Loader>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr v-for="(item, index) in $parent.InvoicesList" :key="index" 
						:data-id="item.id" :id="'tr-'+item.id"
						v-bind:class="[(item.id==$parent.selected) ? 'active' : '']"
					>
						<td class="note">
							<span :class="'newInvo newInvo-' + item.id" v-if="item.pusher == 1">
								New!
							</span>
							<button  @click="$parent.actionNotes(item.id, item.notes)"
								type="button" 
								title="Edit Notes"
								:class="[(item.notes > 0) ? 'btn btn-warning' : 'btn btn-secondary no-notes']"
								style="padding: 0px 3px; font-size: 16px; line-height: 1;"
							>
								<i class="far fa-sticky-note"></i>
								<span class="textIcon" style="display: none;"> Edit Note</span>
							</button>
						</td>
						<td class="numID"  v-if="$parent.cols.includes('1')" @click="$parent.activeTR(item.id)">
							<div class="numID-container">
								<div class="col1">
									<div class="row1 case1" v-if="item.idxstatus !== 2 && item.idxstatus !== 3 && item.idxstatus !== 5" @click="$parent.actionEdit(item.id)">
										<span class="btn-edit" @click="$parent.actionEdit(item.id)">
											Edit
										</span>
										<span class="numid">#{{ item.numdoc }}</span>
									</div>
									<div class="row1 case2" v-else >
										<span class="btn-edit no-edit">
											Edit
										</span>
										<span class="numid">#{{ item.numdoc }}</span>
									</div>
									<div class="row2">
										{{ item.fecdoc.slice(0, 10) | moment("MMM DD, YYYY")}}
									</div>
								</div>
								<div class="col2">
									<span class="btn-pdf" @click="$parent.actionPdf(item.id)" style="font-weight: bold; text-shadow: none; box-shadow: none; color:#555;">
										PDF
									</span>
									<span v-if="item.rec == 1" class="badge badge-dark rec">Rec</span>
									<!-- <span v-else class="badge badge-dark rec no-rec">Rec</span> -->
								</div>
							</div>
						</td>
						<td class="date-due" v-if="$parent.cols.includes('3')" @click="$parent.activeTR(item.id)">
							{{ item.fecdue.slice(0, 10) | moment("MMM DD, YYYY")}}
						</td>
						<td class="customer" v-if="$parent.cols.includes('4')" @click="$parent.activeTR(item.id)" >
							{{ item.firstname }}
							{{ item.lastname }}<br />
							<span style="color: #a9a9a9">
								{{item.bussinesname}}
							</span>
						</td>
						<td  class="name" v-if="$parent.cols.includes('5')" @click="$parent.activeTR(item.id)">
							<input type="text" class="form-control edit-name" v-model="item.invoicename" @change="$parent.setValueTable($parent.InvoicesList, item.id, 'invoicename', item.invoicename)" />
						</td>
						<td class="total"  style="text-align: right" v-if="$parent.cols.includes('6')" @click="$parent.activeTR(item.id)">
							${{ item.total | formatMoney }}
						</td>
						<td  class="tax"  style="text-align: right" v-if="$parent.cols.includes('7')" @click="$parent.activeTR(item.id)">
							<span v-if="item.tax !== 0">
								${{item.tax | formatMoney}}
							</span>
							<span v-else>--</span>
						</td>
						<td  class="balance"  style="text-align: right; cursor: pointer;" v-if="$parent.cols.includes('8')">
							<DropdownMenu :buttonClass="['arrow-down btn-balance']">
								<template v-slot:button>
									<span v-if="item.balance!=null">
										${{ item.balance | formatMoney }}
									</span>
									<span v-else>$0.00</span>
								</template>
								<template v-slot:menu>
									<ul style="margin: 0; padding: 0; list-style: none">
										<li @click="$parent.statement(item.id, item.customer_id)" v-if="[2, 3].includes(item.idxstatus) && $parent.valOpAddi.includes('2')">
											<button>
												<i class="fas fa-file-invoice-dollar"></i>
												Statement
											</button>
										</li>
										<li v-if="item.idxstatus !== 3 && item.idxstatus !== 5"
											@click="$parent.actionPay(item.id,item.numdoc,item.total,item.customer_id,item.firstname,item.lastname,item.bussinesname,item.balance,item)"
										>
											<button class="text-left textAction">
												<i class="fas fa-dollar-sign"></i>
												Make a Payment
											</button>
										</li>
										<li v-if="item.idxstatus !== 3 && item.idxstatus !== 5"
											@click="$parent.SquarePay(item.id,item.numdoc,item.total,item.customer_id,item.firstname,item.lastname,item.bussinesname,item.balance)"
											v-bind:class="[
												'action',
												($parent.validAccountSquare) ? 'active' : 'inactive',
											]"
										>
											<button class="text-left textAction">
												<iconSquareUp></iconSquareUp>
												Pay with Square Up
											</button>
										</li>
									</ul>
								</template>
							</DropdownMenu>
						</td>
						<td  class="status"  style="text-align: center" v-if="$parent.cols.includes('9')" @click="$parent.activeTR(item.id)">
							<DropdownMenu
								:buttonClass="['arrow-down btn-status',
									(item.idxstatus == 1) ? 'pending' :
										(item.idxstatus == 2) ? 'partial' :
											(item.idxstatus == 3) ? 'paid' :
												(item.idxstatus == 4) ? 'overdue' :
													(item.idxstatus == 5) ? 'void' : ''
									]"
							>
								<template v-slot:button>
										<span v-for="(i, idx) in $parent.statusdata" :key="idx"
											v-if="item.idxstatus == i.value">
											{{ i.name }}
										</span>
								</template>
								<template v-slot:menu>
									<ul style="margin: 0; padding: 0; list-style: none">
										<li v-if="item.idxstatus != 5" @click="$parent.setValueTable($parent.InvoicesList, item.id, 'idxstatus', 5)">
											Void
										</li>
										<li v-if="item.idxstatus == 5 " @click="$parent.MetDeleteInvoice(item.id)">
											Delete
										</li>
										<li v-if="item.idxstatus == 5 " @click="$parent.setValueTable($parent.InvoicesList, item.id, 'idxstatus', 1)">
											Pending
										</li>
									</ul>
								</template>
							</DropdownMenu>
						</td>
						<td  class="send" v-if="$parent.cols.includes('11')" >
							<button class="btn-mail" @click="$parent.actionEmail(item.id, item.email,item.numdoc)"
								style=" border: 0;background: transparent;cursor: pointer;font-size: 13px;color: #212529;">
								<sup :class="(item.numemaienv > 0) ? '' : 'none'">
									{{ item.numemaienv }}
								</sup>
								<i :class="['fas fa-envelope', (item.numemaienv == 0) ? 'inactivo' : '']"></i>
							</button>
							<button type="button" v-if="$parent.showSMS == 1" class="btn-sms" @click="$parent.SendPDFbySMS(item, item.customer_id, 'invoice')" title="Send by SMS">
								<sup :class="(item.numenvsms > 0) ? '' : 'none'">{{item.numenvsms }}</sup>
								<i :class="['fas fa-sms', (item.numenvsms == 0) ? 'inactivo' : '']"></i>
							</button>
						</td>
						<td class="jobs" v-if="$parent.cols.includes('12') && $parent.accessJobsApp && $parent.JobsInt==1">
							<button v-if="item.job.id==0"
								class="text-left textAction btn btn-light btn-sm tooltip-show"
								style="border: 1px solid #dcdcdc;background-color: #fff;position: relative;"
								@click="$parent.convertToJobs(item.id,item.numdoc,item.total,item.customer_id,item)"
							>
								<i class="fas fa-arrow-right"></i>
								<!-- <span class="tooltipInvo">Convert to Job</span> -->
							</button>
							<span v-else>
								<span v-if="item.job.id_status==4"
									style="position: relative;"
									v-bind:class="[
										'tooltipJob-show badge',
										(item.job.id_status==4) ? 'badge-success' : '',
									]"
								>
									<span class="tooltipJob">Job ID #{{item.job.id}}</span>
									{{item.job.statusName}}
								</span>
								<DropdownMenu v-else :buttonClass="
									[
										'arrow-down btn btn-job-status',
										([1].includes(item.job.id_status)) ? 'btn-secondary pending textW' :
											([2].includes(item.job.id_status)) ? 'btn-info info textW' : ''
									]"
								>
									<template v-slot:button>
										{{item.job.statusName}}
									</template>
									<template v-slot:menu>
										<ul style="margin: 0; padding: 0; list-style: none">
											<li @click="$parent.jobstoCompleted(item.job.id, item)">
												<button>
													<i class="fas fa-check"></i>
													Completed
												</button>
											</li>
										</ul>
									</template>
								</DropdownMenu>
							</span>
						</td>
						<td class="calc" v-if="$parent.cols.includes('13')">
							<button type="button"
								@click="$parent.openCalculator(item, index)">
								<i :class="['fas fa-calculator', item.calc_inv.isCalc!=1 ? 'inactivo' : '']"></i>
							</button>
						</td>
						<td class="actions">
							<DropdownMenu buttonClass="base">
								<template v-slot:button>
									<i class="fas fa-ellipsis-v"></i>
								</template>
								<template v-slot:menu>
									<ul style="margin: 0; padding: 0; list-style: none">
										<li @click="$parent.actionPdf(item.id)">
											<button>
												<i class="fas fa-file-pdf"></i>
												Open PDF
											</button>
										</li>
										<li @click="$parent.actionPDFforEnvelope(item.id)" v-if="$parent.valOpAddi.includes('1')">
											<button>
												<i class="fas fa-file-pdf"></i>
												Open PDF for
												Envelope
											</button>
										</li>
										<li @click="$parent.actionPrint(item.id)" v-if="$parent.validEprint">
											<button class="text-left textAction">
												<i class="fas fa-print"></i>
												ePrint
											</button>
										</li>
										<li v-if="$parent.showSMS==1"
											@click="$parent.SendPDFbySMS(item, item.customer_id, 'invoice')"
											v-bind:class="[
												'action',
												($parent.PlanPremium) ? 'active' : 'inactive',
											]"
										>
											<button
												class="text-left textAction">
												<i class="fas fa-envelope"></i>
												Send PDF by SMS
												</button>
										</li>
										<li v-if="item.idxstatus !== 3 && item.idxstatus !== 5"
											@click="$parent.actionPay(item.id,item.numdoc,item.total,item.customer_id,item.firstname,item.lastname,item.bussinesname,item.balance,item)"
										>
											<button class="text-left textAction">
												<i class="fas fa-dollar-sign"></i>
												Make a Payment
											</button>
										</li>
										<li v-if="item.idxstatus !== 3 && item.idxstatus !== 5"
											@click="$parent.SquarePay(item.id,item.numdoc,item.total,item.customer_id,item.firstname,item.lastname,item.bussinesname,item.balance)"
											v-bind:class="[
												'action',
												($parent.validAccountSquare) ? 'active' : 'inactive',
											]"
										>
											<button class="text-left textAction">
												<iconSquareUp></iconSquareUp>
												Pay with Square Up
											</button>
										</li>
										<li @click="$parent.statement(item.id, item.customer_id)" v-if="$parent.valOpAddi.includes('2')">
											<button>
												<i class="fas fa-file-invoice-dollar"></i>
												Statement
											</button>
										</li>
										<li v-if="$parent.valOpAddi.includes('3') && item.idxstatus !== 5"
											@click="$parent.actionDuplicate(item.id)"
										>
											<button>
												<i class="fas fa-copy"></i>
												Duplicate
											</button>
										</li>
										<li
											v-if="$parent.valOpAddi.includes('4') && item.idxstatus !==5"
											@click="$parent.convertRecurring(item.id)"
										>
											<button>
												<i class="fas fa-file-alt"></i>
												Convert to
												Recurring
											</button>
										</li>
										<li @click="$parent.actionEdit(item.id)" 
											v-if="item.idxstatus !== 2 &&
											item.idxstatus !== 3 &&
											item.idxstatus !== 5 "
										>
											<button class="text-left textAction">
												<i class="fas fa-edit"></i>
												Edit
											</button>
										</li>
										<li @click="$parent.actionVoid(item.id)"
											v-if="item.idxstatus !==5"
										>
											<button class="text-left textAction">
												<i class="fas fa-trash-alt"></i>
												Void
											</button>
										</li>
										<li @click="$parent.MetDeleteInvoice(item.id)" v-if=" item.idxstatus == 1 || item.idxstatus == 4 || 
											item.idxstatus == 5 "
										>
											<button
												class="text-left textAction">
												<i class="fas fa-times"></i>
												Delete
												</button>
										</li>
									</ul>
								</template>
							</DropdownMenu>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center d-block w-100 p20" v-if="$parent.InvoicesList.length == 0 && $parent.isFilter == true" style="position: absolute;top: 40px;z-index: 1;left: 0;border-bottom: 1px solid #ddd;">
				<div class="text-center" style="padding: 80px; background: #fff">
					No record
				</div>
			</div>
			<div class="text-center d-block w-100 p20" v-if="$parent.InvoicesList.length == 0 && !$parent.isFilter && !$parent.isLoading"style="position: absolute;top: 40px;z-index: 1;left: 0;border-bottom: 1px solid #ddd;">
				<div class="text-center" style="padding: 80px; background: #fff">
					<span>Its time to create your first Invoice! </span><br />
					<router-link
						v-if="!$parent.freePlan"
						:to="{ name: 'InvoicesNew' }"
						class="btn btn-success"
						style="margin-top: 7px"
						>Create New Invoice</router-link>
						<button type="button" 
							v-else
							@click="$parent.llamarPopPremium()"
							class="btn btn-success disabled"
						>
							<i class="fas fa-plus"></i>
							Create New Invoice
						</button>
				</div>
			</div>
		</div>
		<table :class="['table table-striped table-bordered table-hover invoList table-footer', $parent.InvoicesList.length == 0 ? 'tfoot_fullwidth' : '']">
			<tfoot>
				<tr>
					<td :colspan="$parent.cols.length+1">
						<ul v-if="$parent.InvoicesList.length > 0"
							class="pagination justify-content-between"
							style="borde: 1px solid blue"
						>
							<li>
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">Show: </div>
									</div>
									<select
										class="form-control selectRowList"
										v-model="$parent.rowNum"
									>
										<option v-for="i in $parent.rowList" :key="i" :value="i">{{i}}</option>
									</select>
								</div>
							</li>
							<li class="page-car">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">Pag: </div>
									</div>
									<select
										v-model="$parent.page"
										class="form-control selectRowList"
										v-on:change="$parent.changePage($parent.page)"
									>
										<option v-for="i in $parent.numPag" :key="i" :value="i">{{i}}</option>
									</select>
								</div>
							</li>
							<li>
								<span class="page-view">View {{ $parent.pagination.to}} of {{ $parent.pagination.total}}</span>
							</li>
						</ul>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
</template>
<script>
import Loader from '@/core/components/shared/Loader'
import iconSquareUp from '@/apps/billing/components/iconSquareUp'
import DropdownMenu from '@/core/components/DropdownMenu.vue'
import '@/apps/billing/views/invoice/css/tableinvo.scss';
export default {
	name: 'tablaInvo',
	components: {
		Loader,
		iconSquareUp,
		DropdownMenu,
	}
}
</script>
<style lang="scss" scoped>

</style>
